import { id } from '@volkswagen-onehub/gfa-disclaimer-manager';
import { DisclaimerManagerLegalProxy } from './disclaimer-manager-legal-proxy';
import { DisclaimerManagerV1Impl } from './v1';
export * from './v1';
export * from './disclaimer-manager-legal-proxy';
const EMPTY_SCOPED_MANAGER_KEY = '---DEFAULT---';
/**
 * Used to get the certain scope of DisclaimerManager
 * If it doesn't exist, it is created and stored inside managers
 */
function getOrCreateV1Manager(scope, managers, options) {
    if (!managers[scope]) {
        managers[scope] = new DisclaimerManagerV1Impl(scope, options);
    }
    return managers[scope];
}
export const defineDisclaimerManagerFactory = (options) => ({
    id: 'internal:disclaimer-manager-factory',
    create: () => {
        const managers = {};
        const defaultScopesForConsumers = {};
        const defaultLegalForConsumer = {};
        const setDefaultScopeForConsumer = (consumerId, scope) => {
            defaultScopesForConsumers[consumerId] = scope;
        };
        const setDefaultLegalForConsumer = (consumerId, legalEntity) => {
            defaultLegalForConsumer[consumerId] = legalEntity;
        };
        const getV1 = (consumerId) => (scope, legalEntity) => {
            const scopeToGet = scope ||
                defaultScopesForConsumers[consumerId] ||
                EMPTY_SCOPED_MANAGER_KEY;
            // Set as default if this consumer id doesn't have one yet
            if (!defaultScopesForConsumers[consumerId]) {
                defaultScopesForConsumers[consumerId] = scopeToGet;
            }
            // If we have legal entity specified for consumer / FApp
            const legalToGet = legalEntity
                ? legalEntity
                : defaultLegalForConsumer[consumerId];
            return new DisclaimerManagerLegalProxy(getOrCreateV1Manager(scopeToGet, managers, options), legalToGet);
        };
        const factory = (consumerId) => ({
            getScopedDisclaimerManager: getV1(consumerId),
            setDefaultScopeForConsumer,
            setDefaultLegalForConsumer
        });
        return {
            '1.0.0': () => ({
                featureService: factory
            })
        };
    }
});
export const defineDisclaimerManager = () => ({
    id: 'disclaimer-manager',
    dependencies: {
        featureServices: {
            'internal:disclaimer-manager-factory': '^1.0.0'
        }
    },
    create: env => {
        const factoryFn = env.featureServices['internal:disclaimer-manager-factory'];
        return {
            '1.4.0': (consumerId) => ({
                featureService: factoryFn(consumerId)
            })
        };
    }
});
export const defineGfaDisclaimerManager = () => ({
    id,
    dependencies: {
        featureServices: {
            'internal:disclaimer-manager-factory': '^1.0.0'
        }
    },
    create: ({ featureServices }) => {
        const factoryFn = featureServices['internal:disclaimer-manager-factory'];
        return {
            '1.0.0': consumerId => ({
                featureService: factoryFn(consumerId)
            })
        };
    }
});
export const defineDisclaimerManagers = (options) => [
    defineDisclaimerManagerFactory(options),
    defineGfaDisclaimerManager(),
    defineDisclaimerManager()
];
export { DisclaimerManagerV1Impl } from './v1/disclaimer-manager-v1';
export { DisclaimerManagerLegalProxy } from './disclaimer-manager-legal-proxy';
